// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3u9nb","icon":"SortAdornment_icon__eMx_B","up":"SortAdornment_up__2KRxR","down":"SortAdornment_down__3VN_B","active":"SortAdornment_active__7MimY"};